import { Injectable } from '@angular/core';
import { Constants } from '../constants/constants';
import { SearchParam, SearchedData, SearchPayload, SearchFilters } from '../shared/model/searched-data.model';
import { ApiService } from './api.service';
import { Router, NavigationEnd, NavigationError, Event } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { UtilService } from './util.service';
import { ToastService } from './toast.service';
import { BehaviorSubject } from 'rxjs';
import { isNullOrUndefined } from '../modules/shared/utils';

@Injectable({
  providedIn: 'root'
})
export class SearchDataService {

  private DEFAULT_PLACEHOLDER: string = "Search VIN, Package..."; //Location...

  searchParam: SearchParam = new SearchParam(null, null);

  searchedDataFromApi: Array<SearchedData>;

  //Searched data variables
  searchedPackages: Array<any>;
  searchedServices: Array<any>;
  searchedVehicles: Array<any>;
  searchedLocations: Array<any>;

  public searchPlaceholder = new BehaviorSubject<string>(this.DEFAULT_PLACEHOLDER);
  public currentSearchPlaceholder = this.searchPlaceholder.asObservable();

  public searchedData = new BehaviorSubject<any>(null);
  public currentSearchedData = this.searchPlaceholder.asObservable();

  // public searchedLocations = new BehaviorSubject<any>(null);
  // public currentSearchedLocations = this.searchedLocations.asObservable();

  // public searchedPackage = new BehaviorSubject<any>(null);
  // public currentSearchedPackage = this.searchedPackage.asObservable();

  // public searchedService = new BehaviorSubject<any>(null);
  // public currentSearchedService = this.searchedService.asObservable();

  // public searchedVehicles = new BehaviorSubject<any>(null);
  // public currentSearchedVehicles = this.searchedVehicles.asObservable();

  payloadExtra: any = {
    fromDate: null,
    toDate: null
  };
  searchKey = null;

  constructor(private router: Router, private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toastService: ToastService) {
    this.initSearchedVariables();
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        // console.log("route::", event);
        this.searchParam = this.getSearchParam(event.url);
        // reset payload
        this.payloadExtra = null;
      }

      // if (event instanceof NavigationError) {
      //   console.log("navigation error::", event.error);
      //   this.searchParam = null;
      // }
    });
  }

  initSearchedVariables() {
    this.searchedPackages = new Array();
    this.searchedServices = new Array();
    this.searchedVehicles = new Array();
    this.searchedLocations = new Array();
  }

  public searchForData(searchKey: string) {
    this.searchKey = searchKey;
    if (searchKey == undefined || searchKey == null) return;
    if (this.searchParam == undefined || this.searchParam == null) {
      this.toastService.showError(Constants.SEARCH_NOT_AVAILABLE_MESSAGE);
      return;
    }

    this.resetPreviousSearchResult();
    var payload = this.getPayload(searchKey)

    console.log("Search payload::", payload);
    this.search(payload);
  }

  public resetPreviousSearchResult(): void {
    this.searchedData.next(null);
    this.searchedDataFromApi = null;
    this.initSearchedVariables();
    // this.searchedLocations.next(null);
    // this.searchedVehicles.next(null);
    // this.searchedPackage.next(null);
    // this.searchedService.next(null);
  }

  private getPayload(searchKey: string) {
    var payload: SearchPayload = new SearchPayload();
    payload.searchKey = searchKey;
    payload = this.setScope(payload)
    payload = this.setFilters(payload);
    return payload;
  }

  setScope(payload: SearchPayload): SearchPayload {
    if (this.searchParam && this.searchParam.scope) {
      payload.scope = this.searchParam.scope;
    }
    return payload;
  }

  setFilters(payload: SearchPayload): SearchPayload {
    if (this.searchParam == null || this.searchParam.filters == null) return payload;
    payload.filters = new SearchFilters();
    payload.filters.accountId = this.authService.accountData.id;
    // payload.filters.category = this.authService.accountData.category;
    if (!isNullOrUndefined(this.payloadExtra)) {
      if (!isNullOrUndefined(this.payloadExtra.fromDate)) payload.filters.fromDate = this.payloadExtra.fromDate;
      if (!isNullOrUndefined(this.payloadExtra.toDate)) payload.filters.toDate = this.payloadExtra.toDate;
    }
    return payload;
  }

  assignData(data: Array<SearchedData>) {
    console.log("assigning data");
    data.forEach(element => {
      switch (element.type) {
        case Constants.SERVICE_PACKAGE:
          this.searchedPackages = element.results;
          break;
        case Constants.SERVICE:
          this.searchedServices = element.results;
          break;
        case Constants.VEHICLES:
          this.searchedVehicles = element.results;
          break;
        case Constants.LOCATIONS:
          this.searchedLocations = element.results;
          break;

        default:
          break;
      }
    });
  }

  public getSearchedDataForType(type: string): Array<any> {
    // console.log("get search result for type::", type);
    if (this.searchedDataFromApi != null && this.searchedDataFromApi != undefined && this.searchedDataFromApi.length > 0) {
      var index = this.searchedDataFromApi.findIndex(item => item.type == type);
      console.log("data::", this.searchedDataFromApi, "::", "index::", index);
      if (index != -1) {
        return this.searchedDataFromApi[index].results;
      }
    }

    return new Array();
  }

  getSearchParam(currentRoute: string): SearchParam {
    currentRoute = this.processRoute(currentRoute);
    // console.log("current route string::", currentRoute);
    this.setSearchPlaceholder(currentRoute);

    return Constants.SEARCH_PARAM.get(currentRoute);
  }

  private setSearchPlaceholder(currentRoute: string) {
    var searchParam = Constants.SEARCH_PARAM.get(currentRoute);
    var searchPlaceholder = "Search";
    if (searchParam && searchParam.placeholder) {
      searchPlaceholder = searchParam.placeholder;
    }
    this.searchPlaceholder.next(searchPlaceholder);
  }

  processRoute(currentRoute: string): string {
    if (currentRoute.indexOf('?') > 0) {
      return currentRoute.slice(0, currentRoute.indexOf('?'));
    }
    return currentRoute;
  }

  search(payload: any) {
    this.utilService.showSpinner();
    this.apiService.searchData(payload).then((data) => {
      this.utilService.hideSpinner();
      console.log("search result ::", data);
      if (!this.isSearchResultFound(payload, data)) {
        this.toastService.showError(Constants.SEARCH_RESULT_NOT_FOUND);
      } else {
        this.searchedDataFromApi = data;
        // this.searchedDataFromApi = this.searchedDataFromApi2;
        this.searchedData.next(data);
      }
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.search(payload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  isSearchResultFound(request, response) {
    var flag = true;
    if (request && request.scope == Constants.SERVICE_USAGE && response && response.length > 0
      && (response[0].results == null || response[0].results.length == 0)) {
      flag = false;
    }
    else if (request && request.scope == Constants.USERS_ENTITY && response && response.length > 0
      && (response[0].results == null || response[0].results.length == 0)) {
      flag = false;
    } else if (response == null || response.length == 0) {
      flag = false;
    }
    return flag;
  }

  searchedDataFromApi2 = [
    {
      "type": "LOCATIONS",
      "results": [
        {
          "id": "5d8b554107d14f5cef8eeb4b",
          "address": {
            "name": "Test",
            "street": "400 Duke Dr",
            "city": "Franklin",
            "state": "TN",
            "zipCode": "37067"
          },
          "type": "FACILITY",
          "vehiclesAtHomeLocation": 0,
          "vehiclesAtAwayLocation": 0,
          "vehiclesFromAwayLocation": 0
        },
        {
          "id": "5d9195e207d14f07b04966c6",
          "address": {
            "name": "Test1",
            "street": "400 Duke Dr 2",
            "city": "Franklin",
            "state": "TN",
            "zipCode": "37067"
          },
          "type": "FACILITY",
          "vehiclesAtHomeLocation": 0,
          "vehiclesAtAwayLocation": 0,
          "vehiclesFromAwayLocation": 0
        },
        {
          "id": "5d92060f07d14f07b04966c8",
          "address": {
            "name": "Test Location",
            "street": "821",
            "city": "Dallas",
            "state": "PA",
            "zipCode": "18612"
          },
          "type": "FACILITY",
          "vehiclesAtHomeLocation": 0,
          "vehiclesAtAwayLocation": 0,
          "vehiclesFromAwayLocation": 0
        },
        {
          "id": "5da9618607d14f07b04966ca",
          "address": {
            "name": "Test 12",
            "street": "la place hotel king",
            "city": "La Place",
            "state": "LA",
            "zipCode": "70068"
          },
          "type": "FACILITY",
          "vehiclesAtHomeLocation": 0,
          "vehiclesAtAwayLocation": 0,
          "vehiclesFromAwayLocation": 0
        },
        {
          "id": "5db7ce3c07d14f4ed8248d6d",
          "coordinate": {
            "latitude": 42.8099372,
            "longitude": -73.95379989999999,
            "latlongUOM": "°"
          },
          "address": {
            "street": "3 main",
            "city": "Schenectady",
            "state": "NY",
            "zipCode": "12345"
          },
          "type": "FACILITY",
          "vehiclesAtHomeLocation": 0,
          "vehiclesAtAwayLocation": 0,
          "vehiclesFromAwayLocation": 0
        }
      ]
    },
    {
      "type": "SERVICE_USAGE",
      "results": [
        {
          "accountId": "5c992c5307d14f083ac8e721",
          "enterpriseId": "5c80ddfb07d14f229f0db62f",
          "correlationId": "21F743795E4B4BBCA1F19C2358596BFC",
          "userId": "708bdf42-3d5e-401b-9656-ba4e5910101d",
          "vin": "[5N1AT2MT2KC797442]",
          "vins": [
            "5N1AT2MT2KC797442"
          ],
          "serviceName": "PUSH_NOTIFICATION",
          "operation": "NOTIFICATION",
          "operationStatus": "SUCCESS",
          "operationType": "BULK",
          "statusMessage": "REMOTE_LIGHT FAILED for 5N1AT2MT2KC797442",
          "facilityLocation": {
            "id": "5c97340c07d14f73c7ed6335",
            "address": {
              "name": "Duke",
              "street": "400 Duke Dr",
              "city": "Franklin",
              "state": "TN",
              "country": null,
              "zipCode": "37067"
            }
          },
          "serviceLocation": {
            "id": null,
            "address": null
          },
          "command": "REMOTE_LIGHT",
          "requestTime": 1573129677470,
          "packageId": null
        },
        {
          "accountId": "5c992c5307d14f083ac8e721",
          "enterpriseId": "5c80ddfb07d14f229f0db62f",
          "correlationId": "21F743795E4B4BBCA1F19C2358596BFC",
          "userId": "708bdf42-3d5e-401b-9656-ba4e5910101d",
          "vin": "[5N1AT2MT2KC797442]",
          "vins": [
            "5N1AT2MT2KC797442"
          ],
          "serviceName": "PUSH_NOTIFICATION",
          "operation": "NOTIFICATION",
          "operationStatus": "SUCCESS",
          "operationType": "BULK",
          "statusMessage": "REMOTE_LIGHT FAILED for 5N1AT2MT2KC797442",
          "facilityLocation": {
            "id": "5c97340c07d14f73c7ed6335",
            "address": {
              "name": "Duke",
              "street": "400 Duke Dr",
              "city": "Franklin",
              "state": "TN",
              "country": null,
              "zipCode": "37067"
            }
          },
          "serviceLocation": {
            "id": null,
            "address": null
          },
          "command": "REMOTE_LIGHT",
          "requestTime": 1573129677451,
          "packageId": null
        },
        {
          "accountId": "5c992c5307d14f083ac8e721",
          "enterpriseId": "5c80ddfb07d14f229f0db62f",
          "correlationId": "21F743795E4B4BBCA1F19C2358596BFC",
          "userId": "708bdf42-3d5e-401b-9656-ba4e5910101d",
          "vin": "[5N1AT2MT2KC797442]",
          "vins": [
            "5N1AT2MT2KC797442"
          ],
          "serviceName": "PUSH_NOTIFICATION",
          "operation": "NOTIFICATION",
          "operationStatus": "FAILED",
          "operationType": "BULK",
          "statusMessage": "REMOTE_LIGHT FAILED for 5N1AT2MT2KC797442",
          "facilityLocation": {
            "id": "5c97340c07d14f73c7ed6335",
            "address": {
              "name": "Duke",
              "street": "400 Duke Dr",
              "city": "Franklin",
              "state": "TN",
              "country": null,
              "zipCode": "37067"
            }
          },
          "serviceLocation": {
            "id": null,
            "address": null
          },
          "command": "REMOTE_LIGHT",
          "requestTime": 1573129677424,
          "packageId": null
        },
        {
          "accountId": "5c992c5307d14f083ac8e721",
          "enterpriseId": "5c80ddfb07d14f229f0db62f",
          "correlationId": "21F743795E4B4BBCA1F19C2358596BFC",
          "userId": "708bdf42-3d5e-401b-9656-ba4e5910101d",
          "vin": "[5N1AT2MT2KC797442]",
          "vins": [
            "5N1AT2MT2KC797442"
          ],
          "serviceName": "PUSH_NOTIFICATION",
          "operation": "NOTIFICATION",
          "operationStatus": "FAILED",
          "operationType": "BULK",
          "statusMessage": "REMOTE_LIGHT FAILED for 5N1AT2MT2KC797442",
          "facilityLocation": {
            "id": "5c97340c07d14f73c7ed6335",
            "address": {
              "name": "Duke",
              "street": "400 Duke Dr",
              "city": "Franklin",
              "state": "TN",
              "country": null,
              "zipCode": "37067"
            }
          },
          "serviceLocation": {
            "id": null,
            "address": null
          },
          "command": "REMOTE_LIGHT",
          "requestTime": 1573129677407,
          "packageId": null
        },
        {
          "accountId": "5c992c5307d14f083ac8e721",
          "enterpriseId": "5c80ddfb07d14f229f0db62f",
          "correlationId": "21F743795E4B4BBCA1F19C2358596BFC",
          "userId": "708bdf42-3d5e-401b-9656-ba4e5910101d",
          "vin": "[5N1AT2MT2KC797442]",
          "vins": [
            "5N1AT2MT2KC797442"
          ],
          "serviceName": "PUSH_NOTIFICATION",
          "operation": "NOTIFICATION",
          "operationStatus": "FAILED",
          "operationType": "BULK",
          "statusMessage": "REMOTE_LIGHT FAILED for 5N1AT2MT2KC797442",
          "facilityLocation": {
            "id": "5c97340c07d14f73c7ed6335",
            "address": {
              "name": "Duke",
              "street": "400 Duke Dr",
              "city": "Franklin",
              "state": "TN",
              "country": null,
              "zipCode": "37067"
            }
          },
          "serviceLocation": {
            "id": null,
            "address": null
          },
          "command": "REMOTE_LIGHT",
          "requestTime": 1573129677311,
          "packageId": null
        },
        {
          "accountId": "5c992c5307d14f083ac8e721",
          "enterpriseId": "5c80ddfb07d14f229f0db62f",
          "correlationId": "21F743795E4B4BBCA1F19C2358596BFC",
          "userId": "708bdf42-3d5e-401b-9656-ba4e5910101d",
          "vin": "[5N1AT2MT2KC797442]",
          "vins": [
            "5N1AT2MT2KC797442"
          ],
          "serviceName": "PUSH_NOTIFICATION",
          "operation": "NOTIFICATION",
          "operationStatus": "FAILED",
          "operationType": "BULK",
          "statusMessage": "REMOTE_LIGHT FAILED for 5N1AT2MT2KC797442",
          "facilityLocation": {
            "id": "5c97340c07d14f73c7ed6335",
            "address": {
              "name": "Duke",
              "street": "400 Duke Dr",
              "city": "Franklin",
              "state": "TN",
              "country": null,
              "zipCode": "37067"
            }
          },
          "serviceLocation": {
            "id": null,
            "address": null
          },
          "command": "REMOTE_LIGHT",
          "requestTime": 1573129677295,
          "packageId": null
        },
        {
          "accountId": "5c992c5307d14f083ac8e721",
          "enterpriseId": "5c80ddfb07d14f229f0db62f",
          "correlationId": "21F743795E4B4BBCA1F19C2358596BFC",
          "userId": "708bdf42-3d5e-401b-9656-ba4e5910101d",
          "vin": "[5N1AT2MT2KC797442]",
          "vins": [
            "5N1AT2MT2KC797442"
          ],
          "serviceName": "PUSH_NOTIFICATION",
          "operation": "NOTIFICATION",
          "operationStatus": "FAILED",
          "operationType": "BULK",
          "statusMessage": "REMOTE_LIGHT FAILED for 5N1AT2MT2KC797442",
          "facilityLocation": {
            "id": "5c97340c07d14f73c7ed6335",
            "address": {
              "name": "Duke",
              "street": "400 Duke Dr",
              "city": "Franklin",
              "state": "TN",
              "country": null,
              "zipCode": "37067"
            }
          },
          "serviceLocation": {
            "id": null,
            "address": null
          },
          "command": "REMOTE_LIGHT",
          "requestTime": 1573129677281,
          "packageId": null
        },
        {
          "accountId": "5c992c5307d14f083ac8e721",
          "enterpriseId": "5c80ddfb07d14f229f0db62f",
          "correlationId": "21F743795E4B4BBCA1F19C2358596BFC",
          "userId": "708bdf42-3d5e-401b-9656-ba4e5910101d",
          "vin": "[5N1AT2MT2KC797442]",
          "vins": [
            "5N1AT2MT2KC797442"
          ],
          "serviceName": "PUSH_NOTIFICATION",
          "operation": "NOTIFICATION",
          "operationStatus": "FAILED",
          "operationType": "BULK",
          "statusMessage": "REMOTE_LIGHT FAILED for 5N1AT2MT2KC797442",
          "facilityLocation": {
            "id": "5c97340c07d14f73c7ed6335",
            "address": {
              "name": "Duke",
              "street": "400 Duke Dr",
              "city": "Franklin",
              "state": "TN",
              "country": null,
              "zipCode": "37067"
            }
          },
          "serviceLocation": {
            "id": null,
            "address": null
          },
          "command": "REMOTE_LIGHT",
          "requestTime": 1573129677258,
          "packageId": null
        },
        {
          "accountId": "5c992c5307d14f083ac8e721",
          "enterpriseId": "5c80ddfb07d14f229f0db62f",
          "correlationId": "21F743795E4B4BBCA1F19C2358596BFC",
          "userId": "708bdf42-3d5e-401b-9656-ba4e5910101d",
          "vin": "[5N1AT2MT2KC797442]",
          "vins": [
            "5N1AT2MT2KC797442"
          ],
          "serviceName": "PUSH_NOTIFICATION",
          "operation": "NOTIFICATION",
          "operationStatus": "FAILED",
          "operationType": "BULK",
          "statusMessage": "REMOTE_LIGHT FAILED for 5N1AT2MT2KC797442",
          "facilityLocation": {
            "id": "5c97340c07d14f73c7ed6335",
            "address": {
              "name": "Duke",
              "street": "400 Duke Dr",
              "city": "Franklin",
              "state": "TN",
              "country": null,
              "zipCode": "37067"
            }
          },
          "serviceLocation": {
            "id": null,
            "address": null
          },
          "command": "REMOTE_LIGHT",
          "requestTime": 1573129677237,
          "packageId": null
        },
        {
          "accountId": "5c992c5307d14f083ac8e721",
          "enterpriseId": "5c80ddfb07d14f229f0db62f",
          "correlationId": "21F743795E4B4BBCA1F19C2358596BFC",
          "userId": "708bdf42-3d5e-401b-9656-ba4e5910101d",
          "vin": "[5N1AT2MT2KC797442]",
          "vins": [
            "5N1AT2MT2KC797442"
          ],
          "serviceName": "PUSH_NOTIFICATION",
          "operation": "NOTIFICATION",
          "operationStatus": "FAILED",
          "operationType": "BULK",
          "statusMessage": "REMOTE_LIGHT FAILED for 5N1AT2MT2KC797442",
          "facilityLocation": {
            "id": "5c97340c07d14f73c7ed6335",
            "address": {
              "name": "Duke",
              "street": "400 Duke Dr",
              "city": "Franklin",
              "state": "TN",
              "country": null,
              "zipCode": "37067"
            }
          },
          "serviceLocation": {
            "id": null,
            "address": null
          },
          "command": "REMOTE_LIGHT",
          "requestTime": 1573129677219,
          "packageId": null
        }
      ]
    }
  ];

}
